import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-add',
  templateUrl: './skeleton-add.component.html',
  styleUrls: ['./skeleton-add.component.scss']
})
export class SkeletonAddComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
